module.exports = __webpack_public_path__ + "img/hr-pump-west.23a6e2e7.png";